import { StackNavigationProp, createStackNavigator } from "@react-navigation/stack";
import React from "react";

import CategoryProductList from "@/screens/CategoryProductList";
import HallCategoryList from "@/screens/HallCategoryList";
import Home from "@/screens/Home";
import Product from "@/screens/Product";
import PromotionList from "@/screens/PromotionList";
import PromotionProductList from "@/screens/PromotionProductList";
import InStoreSearch from "@/screens/Search/InStoreSearch";
import StoreFavoriteProductList from "@/screens/StoreFavoriteProductList";
import StoreHallList from "@/screens/StoreHallList";
import StoreHighlight from "@/screens/StoreHighlight";
import StoreHome from "@/screens/StoreHome";
import StoresByType from "@/screens/StoresByType";

export type HomeStackParamList = {
  home: undefined;
  promotions: {
    storeTypeId?: string;
  };
  storesByType: {
    typeId: string;
  };
  storeHome: {
    storeId: string;
  };
  storeHallList: {
    storeId: string;
  };
  hallCategoryList: {
    hallId: string;
  };
  storeHighlight: {
    highlightId: string;
  };
  promotionProductList: {
    storeId: string;
  };
  categoryProductList: {
    categoryId: string;
  };
  storeFavoriteProductList: {
    storeId: string;
  };
  product: {
    productId: string;
  };
  inStoreSearch: {
    storeId: string;
    query?: string;
  };
};

export const HomeRoutePaths = {
  home: "/",
  promotions: "/promocoes",
  storesByType: "/lojas-por-tipo",
  storeHome: "/loja",
  storeHallList: "/loja/corredores",
  storeHighlight: "/loja/destaques",
  hallCategoryList: "/loja/corredores/categorias",
  promotionProductList: "/loja/promocoes",
  storeFavoriteProductList: "/loja/favoritos",
  product: "/loja/produto",
  inStoreSearch: "/loja/busca",
};

export type HomeNavigation = StackNavigationProp<HomeStackParamList>;

const HomeStackNav = createStackNavigator<HomeStackParamList>();

const HomeStack = () => {
  return (
    <HomeStackNav.Navigator
      initialRouteName="home"
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <HomeStackNav.Screen name="home" component={Home} options={{ title: "iFeira" }} />
      <HomeStackNav.Screen
        name="promotions"
        component={PromotionList}
        options={{ title: "Promoções" }}
      />
      <HomeStackNav.Screen
        name="storesByType"
        component={StoresByType}
        options={{ title: "Lojas" }}
      />
      <HomeStackNav.Screen name="storeHome" component={StoreHome} options={{ title: "Loja" }} />
      <HomeStackNav.Screen
        name="storeHallList"
        component={StoreHallList}
        options={{ title: "Corredores" }}
      />
      <HomeStackNav.Screen
        name="storeHighlight"
        component={StoreHighlight}
        options={{ title: "Destaque" }}
      />
      <HomeStackNav.Screen
        name="hallCategoryList"
        component={HallCategoryList}
        options={{ title: "Categorias" }}
      />
      <HomeStackNav.Screen
        name="promotionProductList"
        component={PromotionProductList}
        options={{ title: "Promoções" }}
      />
      <HomeStackNav.Screen
        name="categoryProductList"
        component={CategoryProductList}
        options={{ title: "Produtos" }}
      />
      <HomeStackNav.Screen
        name="storeFavoriteProductList"
        component={StoreFavoriteProductList}
        options={{ title: "Favoritos" }}
      />
      <HomeStackNav.Screen name="product" component={Product} options={{ title: "Produto" }} />
      <HomeStackNav.Screen
        name="inStoreSearch"
        component={InStoreSearch}
        options={{ title: "Busca" }}
      />
    </HomeStackNav.Navigator>
  );
};

export default HomeStack;
